import React from 'react';
import { Button, Card, Row, Col } from '@/components/ui';
import { TaskType } from '../../../types/Task';
import ResponsiveModal from '../../quantified-tracking/components/ResponsiveModal';

interface TaskTypeSelectorProps {
  visible: boolean;
  onClose: () => void;
  onSelect: (type: TaskType) => void;
  availableTypes: TaskType[];
}

const TaskTypeSelector: React.FC<TaskTypeSelectorProps> = ({
  visible,
  onClose,
  onSelect,
  availableTypes
}) => {
  const getTaskTypeIcon = (type: TaskType) => {
    switch (type) {
      case 'Overhead':
        return 'bi-gear';
      case 'Routine':
        return 'bi-calendar-check';
      case 'Quantified':
        return 'bi-calculator';
      case 'Internal':
        return 'bi-building';
      case 'Custom':
        return 'bi-tools';
      default:
        return 'bi-gear';
    }
  };

  const getTaskTypeDescription = (type: TaskType) => {
    switch (type) {
      case 'Overhead':
        return 'A standard overhead task with basic information';
      case 'Routine':
        return 'A recurring task that follows a regular schedule';
      case 'Quantified':
        return 'A task with specific quantities and measurements';
      case 'Internal':
        return 'An internal task for organizational purposes';
      case 'Custom':
        return 'A customizable task for specific project needs';
      default:
        return '';
    }
  };

  if (!visible) return null;

  return (
    <ResponsiveModal
      isOpen={visible}
      onClose={onClose}
      title="Select Task Type"
      footer={
        <Button
          type="button"
          variant="secondary"
          onClick={onClose}
        >
          Cancel
        </Button>
      }
    >
      <Row>
        {availableTypes.map((type) => (
          <Col key={type} md={6}>
            <Card
              className="tw-h-full cursor-pointer"
              onClick={() => onSelect(type)}
              style={{ cursor: 'pointer' }}
            >
              <Card.Body>
                <div className="tw-flex tw-items-center tw-mb-2">
                  <i className={`bi ${getTaskTypeIcon(type)} tw-text-xl tw-mr-2`}></i>
                  <h5 className="tw-mb-0">{type}</h5>
                </div>
                <p className="tw-text-content-muted">
                  {getTaskTypeDescription(type)}
                </p>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </ResponsiveModal>
  );
};

export default TaskTypeSelector; 